import React from 'react';

import { noop } from 'lodash';

import Tag from './Tag';
import { TagsProps } from './types';

import cn from '~/utils/cn';

const Tags: React.FC<TagsProps> = ({ tags, onTagClose = noop, className = '', shouldDisplayClose = false }) => (
  <div className={cn('flex flex-wrap gap-8', className)}>
    {tags.map((tagData) => (
      <Tag
        key={tagData.id}
        text={tagData.text}
        icon={tagData.icon}
        disabled={tagData.disabled}
        className={tagData.className}
        Wrapper={tagData.Wrapper}
        shouldDisplayClose={shouldDisplayClose}
        onClose={() => onTagClose(tagData.id)}
      />
    ))}
  </div>
);

export default Tags;
